import { reduxForm } from 'redux-form'

import { fetchServicing } from '../../actions/servicings'
import { createPinForArea } from '../../actions/pins'

import { goBack } from 'react-router-redux'

import imageToDataURI from '../../helpers/imageToDataURI'

import PinForm from '../../components/pins/pin-form'

const fields = [
  'beforeImage',
  'afterImage',
  'status',
  'description',
  'x',
  'y',
  'areaId'
]

function mapStateToProps (state, ownProps) {
  if (!state.servicings[ownProps.params.areaId]) return {}

  return {
    modalTitle: 'Add a Pin',
    updating: false,
    initialValues: {
      ...ownProps.initialValues,
      x: +ownProps.location.query.x,
      y: +ownProps.location.query.y,
      areaId: state.servicings[ownProps.params.areaId].area
    }
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  dispatch(fetchServicing(ownProps.params.areaId))

  return {
    onSubmit (data) {
      dispatch(createPinForArea(data.areaId, data))
        .then(() => dispatch(goBack()))
    },

    handleClose () {
      dispatch(goBack())
    }
  }
}

export default reduxForm(
  {
    fields,
    form: 'createPin'
  },
  mapStateToProps,
  mapDispatchToProps
)(PinForm)



// WEBPACK FOOTER //
// ./src/containers/pins/create-pin-container.js